import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { MdFilterListOff } from 'react-icons/md';
import { Stack, Typography } from '@mui/material';

import { styles } from './index.styles';

interface StaticGraphWarningProps {
  compact?: boolean;
}

const StaticGraphWarning: FC<StaticGraphWarningProps> = ({ compact }) => {
  const { t } = useTranslation('followUp');

  return (
    <Stack direction="row" sx={styles.staticGraph}>
      {!compact && (
        <Typography variant="caption">{t('staticGraph')}</Typography>
      )}
      <MdFilterListOff size={20} />
    </Stack>
  );
};

export default StaticGraphWarning;
